import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to make and give reasoned judgement.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Ah...isn’t he cute?</p>
                                            <div className="border_subtitle image"><img
                                                src={require('@images/thought_intro.png')}
                                                style={{float: 'right', width:' 250px', clear: 'both'}}/>But why do
                                                you think this baby is attractive?
                                            </div>
                                            <p>Attractiveness is subjective, but there are some people (and
                                                other things)
                                                that nearly everyone finds beautiful. Babies are a good
                                                example of this
                                                point. People tend to look for symmetry in faces as this is
                                                meant to imply
                                                strong genes and hence someone who is fit and healthy. The
                                                golden ratio,
                                                (phi 1:1.618<a className="superscripttext supLinesapce"
                                                               href="further_info.php?course=300"><sup>1</sup></a>),
                                                when present, has been shown to equate to increased
                                                beauty. Whether you believe in the golden ratio or not, you
                                                are merely
                                                trying to short cut the information to make an informed
                                                judgement.
                                                However, relying on this data can skew your judgement. </p>

                                            <div className="lightgreencontentbg lightbgcenter">
                                                <div className="border_subtitle">Objective decisions?</div>
                                                <p>Research indicates that many people are influenced by
                                                    factors in the environment when
                                                    decision making. A person’s physical attractiveness can
                                                    have an impact on whether we
                                                    decide to accept or reject their argument: </p>
                                                <ul className="greenbullet-list paraspace">
                                                    <li>A number of studies<a
                                                        className="superscripttext supLinesapce"
                                                        href="further_info.php?course=300"><sup>2</sup></a> have
                                                        shown that people who are attractive tend to have
                                                        faces
                                                        that more closely resemble that of babies. For
                                                        example, they have rounder faces, and
                                                        their eyes are wider apart than the average.
                                                    </li>
                                                    <li>Physical attractiveness has been shown to be
                                                        perceived to link with character and
                                                        can make individuals be seen as more persuasive.
                                                        Research<a className="superscripttext supLinesapce"
                                                                   href="further_info.php?course=300"><sup>3</sup></a> has
                                                        found that people
                                                        on trial who were rated as attractive were less
                                                        likely to be found guilty or received
                                                        shorter sentences than those perceived to be less
                                                        attractive.
                                                    </li>
                                                    <li className="cntareap">Attractive people are often
                                                        perceived as more intelligent, better adjusted, and
                                                        more
                                                        popular. This is known as the halo effect.<a
                                                            className="superscripttext supLinesapce"
                                                            href="further_info.php?course=300"><sup>4</sup></a> Research
                                                        shows attractive people also
                                                        have more occupational success and more dating
                                                        experience than unattractive
                                                        people.<a className="superscripttext supLinesapce"
                                                                  href="further_info.php?course=300"><sup>5</sup></a> It
                                                        could be, however, that higher self-confidence
                                                        coupled with positive
                                                        feedback equates to more success.
                                                    </li>
                                                </ul>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}